module.exports = __webpack_public_path__ + "media/images/pages/commercial/pocstock-commercial-hero-d9a49732a0738e0e15a41cd8a009c6cd.png";